import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import { DBExportType } from '@/types/export';
import { EndpointResponse } from '@/types/endpoints';
import { utils } from '../../utils';
import type { ReadRequestOptions } from '../requestOptions';

type RequestParams = {
  exportType: DBExportType;
  query?: string;
  limit?: number;
};

type PreviewRecord = Record<string, unknown>;

type Response = {
  count: number;
  records: PreviewRecord[];
};

export const previewExportTypeRecords = async (
  scope: RequestScope,
  { exportType, query, limit = 5 }: RequestParams,
  options: ReadRequestOptions
): Promise<EndpointResponse<Response>> => {
  try {
    const client = scopedApi(scope);
    const [countResponse, sampleResponse] = await Promise.all([
      client.get<EndpointResponse<{ count: number }>>(`${exportType}/count`, {
        ...options,
        params: { ...(query !== undefined && { query }) },
      }),
      client.get<EndpointResponse<PreviewRecord[]>>(`${exportType}`, {
        ...options,
        params: { ...(query !== undefined && { query }), limit },
      }),
    ]);

    if (countResponse.data.isError) return countResponse.data;
    if (sampleResponse.data.isError) return sampleResponse.data;

    return {
      status: sampleResponse.data.status,
      execution_time: sampleResponse.data.execution_time,
      num_results: sampleResponse.data.num_results,
      result: {
        count: countResponse.data.result.count,
        records: Array.isArray(sampleResponse.data.result) ? sampleResponse.data.result : [],
      },
    };
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
